import { app } from "modular-openscriptjs";
import ModalComponent from "../ModalComponent";

const h = app("h");

export default class ModalBody extends ModalComponent {
	name = "ModalBody";
	
	render(...args) {
		return h.div(
			{ class: "modal-content border-0 rounded-5" },
			h.div({ class: "modal-body p-5" }, ...args),
		);
	}
}
